import React, { useContext } from 'react'
import { NavLink } from 'reactstrap'
import { Link } from 'react-router-dom'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { etkinlikArr } from "./EtkinliklerData";


function Etkinlikler() {

  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    lazyLoad: 'ondemand'
  };

  return (
    <>
      <div className='container my-4 mb-1 slick-slider-big'>
        <div className='homeTitle'>
          ETKİNLİK ve ATÖLYELER
          <span className='all'>
            <NavLink tag={Link} to="etkinlikler">Tümünü gör<i class="bi bi-chevron-right"></i></NavLink>
          </span>
        </div>
        <Slider {...settings}>
          {
            etkinlikArr.map((etkinlik, index) => (
              <div className='box'>
                <img src={etkinlik?.src} class="d-block w-100" alt="Konuşmacı" />
              </div>
            ))
          }
        </Slider>
      </div>
    </>
  );
}

export default Etkinlikler;